import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  item: {
    padding: '15px 30px 5px 30px',
    '& .MuiFormHelperText-contained': {
      margin: '0',
    },
    borderRadius: '8px',
    background: '#FFF',
    border: '1px solid rgba(44, 45, 62, 0.3)',
    marginBottom: '40px'
  },
  helperRow: {
    height: '15px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
